import { Capacitor } from '@capacitor/core';

/** True inside the Capacitor shell, where the page origin is https://localhost. */
export const isNative = Capacitor.isNativePlatform();

const SERVER_KEY = 'hmawiw-server';

export function getServerUrl(): string | null {
  try {
    return localStorage.getItem(SERVER_KEY);
  } catch {
    return null;
  }
}

export function setServerUrl(url: string | null): void {
  try {
    if (url) localStorage.setItem(SERVER_KEY, url);
    else localStorage.removeItem(SERVER_KEY);
  } catch {
    // storage unavailable
  }
}

/** Trims, defaults to https, drops trailing slashes and any path. */
export function normalizeServerUrl(input: string): string | null {
  let s = input.trim();
  if (!s) return null;
  if (!/^https?:\/\//i.test(s)) s = `https://${s}`;
  try {
    const u = new URL(s);
    return `${u.protocol}//${u.host}`;
  } catch {
    return null;
  }
}

/** Base URL for API calls: same origin on the web, the configured server in the Android app. */
export function apiBase(): string {
  return isNative ? (getServerUrl() ?? '') : '';
}

export function haptic(kind: 'tick' | 'lift' | 'confirm'): void {
  if (isNative) {
    void import('@capacitor/haptics')
      .then(({ Haptics, ImpactStyle }) => (kind === 'tick' ? Haptics.selectionChanged() : Haptics.impact({ style: kind === 'lift' ? ImpactStyle.Medium : ImpactStyle.Light })))
      .catch(() => undefined);
    return;
  }
  const ms = kind === 'tick' ? 8 : kind === 'lift' ? 15 : 12;
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') navigator.vibrate(ms);
  } catch {
    // vibration not permitted; nothing to do
  }
}

export function isCoarsePointer(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;
}
